module.exports = "<div class=\"ui message {{message.level}}\" *ngIf=\"message?.code\">\n  <i class=\"close icon\" (click)=\"message = null\"></i>\n  <div class=\"header\">{{message.title}}</div>\n  <p>{{message.text}}</p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/messages/messages.component.html
// module id = 1018
// module chunks = 0